import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgPhysicalInspReportFile } from '../models/jg/jg-physical-insp-report-file.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JgPhysicalInspReportFileService extends RequestService<JgPhysicalInspReportFile> {
  static PATH = '/jg/physicalInsp/reportFile';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(
      httpClient,
      JgPhysicalInspReportFileService.PATH,
      globalService.debugUrl,
    );
  }
}
